<template>
	<div class="p-col-12 p-grid">
		<div class="p-col-12 p-lg-6" :class="[commonService.isMobile() ? 'text-box-mobile' : 'text-box']">
		    <p class="login-title">About us</p>
			<p class="login-text justified">At TiroLibre, we are not just a business; we are a team of passionate individuals who are deeply committed to revolutionizing the world of football. We understand the challenges that players and clubs face in this industry, and we are determined to make a difference.</p>
			<p class="login-text justified">Our platform is more than just a tool for transfer negotiations. It is a bridge that connects people from different corners of the world, a platform that brings dreams to life. We are proud to be part of this incredible journey, and we are grateful for every player, club, agent, and coach who has put their trust in us.</p>
		</div>
		<div class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getAboutUs1ImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -80px;
	font-size: xx-large;
}

.login-text {
	margin-top: 10px;
	font-size: 19px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: -40px;
		font-size: x-large;
	}

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}
}
</style>